module.exports = __webpack_public_path__ + "static/media/avlino-icon.3caf5c3a.svg";